<itl-selection
  [title]="node.title"
  [(ngModel)]="value"
  [values]="selectionItems"
  [description]="node.description"
  [icon]="node.globalType ? (node.globalType | globalTypeIcon) : null"
  [required]="node.mandatory"
  showSearch="true"
>
</itl-selection>
